function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { StateHandler, controllerMixin, Messaging } from 'oskari-ui/util';
import { showCoordinatePopup } from './CoordinatePopup';
import { PLACEMENTS } from 'oskari-ui/components/window';
import { getTransformedCoordinates, transformCoordinates, isTransformAllowed as _isTransformAllowed } from './helper';
var UIHandler = /*#__PURE__*/function (_StateHandler) {
  function UIHandler(plugin, mapModule, config) {
    var _this$config$reverseG;
    var _this;
    _classCallCheck(this, UIHandler);
    _this = _callSuper(this, UIHandler);
    _this.plugin = plugin;
    _this.sandbox = Oskari.getSandbox();
    _this.loc = Oskari.getMsg.bind(null, 'coordinatetool');
    _this.mapModule = mapModule;
    _this.config = config;
    var coordinateToolService = Oskari.clazz.create('Oskari.mapframework.bundle.coordinatetool.CoordinateToolService', _this.sandbox, config || {});
    _this.sandbox.registerService(coordinateToolService);
    _this.service = coordinateToolService;
    _this.mapProjection = _this.mapModule.getProjection();
    _this.isReverseGeoCode = _this.config.isReverseGeocode;
    _this.reverseGeocodingIds = (_this$config$reverseG = _this.config.reverseGeocodingIds) === null || _this$config$reverseG === void 0 ? void 0 : _this$config$reverseG.split(',');
    _this.setState({
      xy: {},
      latField: '',
      lonField: '',
      loading: false,
      showMouseCoordinates: false,
      selectedProjection: _this.mapProjection,
      emergencyInfo: null,
      reverseGeocodeNotImplementedError: false,
      reverseGeoCode: [],
      showReverseGeoCode: false,
      approxValue: false
    });
    _this.popupControls = null;
    _this.eventHandlers = _this.createEventHandlers();
    _this.decimalSeparator = Oskari.getDecimalSeparator();
    _this.popupListeners = [];
    _this.addStateListener(function () {
      return _this.updatePopup();
    });
    return _this;
  }
  _inherits(UIHandler, _StateHandler);
  return _createClass(UIHandler, [{
    key: "addPopupListener",
    value: function addPopupListener(func) {
      this.popupListeners.push(func);
    }
  }, {
    key: "notifyPopupListeners",
    value: function notifyPopupListeners(isOpen) {
      this.popupListeners.forEach(function (func) {
        return func(isOpen);
      });
    }
  }, {
    key: "getName",
    value: function getName() {
      return 'CoordinatePluginHandler';
    }
  }, {
    key: "popupCleanup",
    value: function popupCleanup() {
      if (this.popupControls) this.popupControls.close();
      this.popupControls = null;
      this.notifyPopupListeners(false);
    }
  }, {
    key: "updatePopup",
    value: function updatePopup() {
      if (this.popupControls) {
        this.popupControls.update(this.state);
      }
    }
  }, {
    key: "setLoading",
    value: function setLoading(status) {
      this.updateState({
        loading: status
      });
    }
  }, {
    key: "toggleMouseCoordinates",
    value: function toggleMouseCoordinates() {
      this.updateState({
        showMouseCoordinates: !this.state.showMouseCoordinates
      });
    }
  }, {
    key: "toggleReverseGeoCode",
    value: function toggleReverseGeoCode() {
      this.updateState({
        showReverseGeoCode: !this.state.showReverseGeoCode
      });
    }
  }, {
    key: "setLonInputValue",
    value: function setLonInputValue(value) {
      this.updateState({
        lonField: value
      });
    }
  }, {
    key: "setLatInputValue",
    value: function setLatInputValue(value) {
      this.updateState({
        latField: value
      });
    }
  }, {
    key: "isTransformAllowed",
    value: function isTransformAllowed() {
      if (typeof this.__transformAllowed !== 'undefined') {
        return this.__transformAllowed;
      }
      var supportedProjections = this.config.supportedProjections;
      this.__transformAllowed = _isTransformAllowed(supportedProjections);
      return this.__transformAllowed;
    }

    // prefer proj specific and default to global format
  }, {
    key: "getProjectionShowFormat",
    value: function getProjectionShowFormat() {
      var _this$config, _this$config2;
      var selectedProj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.selectedProjection;
      var projection = selectedProj || this.mapProjection;
      var projConfig = ((_this$config = this.config) === null || _this$config === void 0 || (_this$config = _this$config.projectionShowFormat) === null || _this$config === void 0 ? void 0 : _this$config[projection]) || {};
      var globalFormat = (_this$config2 = this.config) === null || _this$config2 === void 0 || (_this$config2 = _this$config2.projectionShowFormat) === null || _this$config2 === void 0 ? void 0 : _this$config2.format;
      return projConfig.format || globalFormat;
    }

    // prefer proj specific, global format, deprecated conf and default to mapmodule logic
  }, {
    key: "getProjectionDecimals",
    value: function getProjectionDecimals() {
      var _conf$projectionShowF, _conf$projectionShowF2;
      var selectedProj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.selectedProjection;
      var projection = selectedProj || this.mapProjection;
      var conf = this.config;
      var projConfig = (conf === null || conf === void 0 || (_conf$projectionShowF = conf.projectionShowFormat) === null || _conf$projectionShowF === void 0 ? void 0 : _conf$projectionShowF[projection]) || {};
      var globalFormat = conf === null || conf === void 0 || (_conf$projectionShowF2 = conf.projectionShowFormat) === null || _conf$projectionShowF2 === void 0 ? void 0 : _conf$projectionShowF2.decimals;
      var decimalCount = projConfig.decimals || globalFormat;
      if (typeof decimalCount === 'number' && decimalCount >= 0) {
        return decimalCount;
      }
      var deprecatedConf = conf === null || conf === void 0 ? void 0 : conf.roundToDecimals;
      if (deprecatedConf) {
        Oskari.log('coordinatetool').warn('Deprecated coordinatetool.conf.roundToDecimals - please use coordinatetool.conf.projectionShowFormat.decimals or ' + 'coordinatetool.conf.projectionShowFormat["projection"].decimals instead.');
        if (typeof deprecatedConf === 'number' && deprecatedConf >= 0) {
          return conf.roundToDecimals;
        }
      }
      return this.mapModule.getProjectionDecimals(projection);
    }
  }, {
    key: "useUserDefinedCoordinates",
    value: function () {
      var _useUserDefinedCoordinates = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var data, isDegrees, converted;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              data = {
                lonlat: {
                  lon: this.formatNumber(this.state.lonField, '.'),
                  lat: this.formatNumber(this.state.latField, '.')
                }
              }; // Check if format should be degrees and add '°' symbol if needed
              isDegrees = this.getProjectionShowFormat() === 'degrees';
              if (isDegrees) {
                if (data.lonlat.lon.indexOf('°') < 0) data.lonlat.lon = data.lonlat.lon + '°';
                if (data.lonlat.lat.indexOf('°') < 0) data.lonlat.lat = data.lonlat.lat + '°';
              }
              _context.n = 1;
              return this.convertCoordinates(data, this.state.selectedProjection, this.mapProjection);
            case 1:
              converted = _context.v;
              this.updateLonLat(converted, true, true, true);
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function useUserDefinedCoordinates() {
        return _useUserDefinedCoordinates.apply(this, arguments);
      }
      return useUserDefinedCoordinates;
    }()
  }, {
    key: "coordinatesToMetric",
    value: function coordinatesToMetric(data) {
      var _data$lonlat, _data$lonlat2;
      var converted = Oskari.util.coordinateDegreesToMetric([(_data$lonlat = data.lonlat) === null || _data$lonlat === void 0 ? void 0 : _data$lonlat.lon, (_data$lonlat2 = data.lonlat) === null || _data$lonlat2 === void 0 ? void 0 : _data$lonlat2.lat], 10);
      return {
        lonlat: {
          lon: converted[0],
          lat: converted[1]
        }
      };
    }
  }, {
    key: "isMapCentered",
    value: function isMapCentered() {
      var _mapXy$lonlat, _this$state$xy, _mapXy$lonlat2, _this$state$xy2;
      var mapXy = this.getMapXY();
      if ((mapXy === null || mapXy === void 0 || (_mapXy$lonlat = mapXy.lonlat) === null || _mapXy$lonlat === void 0 ? void 0 : _mapXy$lonlat.lon) === ((_this$state$xy = this.state.xy) === null || _this$state$xy === void 0 || (_this$state$xy = _this$state$xy.lonlat) === null || _this$state$xy === void 0 ? void 0 : _this$state$xy.lon) && (mapXy === null || mapXy === void 0 || (_mapXy$lonlat2 = mapXy.lonlat) === null || _mapXy$lonlat2 === void 0 ? void 0 : _mapXy$lonlat2.lat) === ((_this$state$xy2 = this.state.xy) === null || _this$state$xy2 === void 0 || (_this$state$xy2 = _this$state$xy2.lonlat) === null || _this$state$xy2 === void 0 ? void 0 : _this$state$xy2.lat)) {
        return true;
      }
      return false;
    }
  }, {
    key: "popupLocation",
    value: function popupLocation() {
      var location = this.plugin.getLocation();
      if (location.includes('right')) {
        return PLACEMENTS.RIGHT;
      } else if (location.includes('left')) {
        return PLACEMENTS.LEFT;
      } else if (location.includes('top')) {
        return PLACEMENTS.TOP;
      } else {
        return PLACEMENTS.BOTTOM;
      }
    }
  }, {
    key: "convertCoordinates",
    value: function () {
      var _convertCoordinates = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(data, fromProjection, toProjection) {
        var _data$lonlat3, _data$lonlat4;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!(this.isTransformAllowed() && this.state.selectedProjection !== this.mapProjection)) {
                _context2.n = 2;
                break;
              }
              if (Oskari.util.coordinateIsDegrees([(_data$lonlat3 = data.lonlat) === null || _data$lonlat3 === void 0 ? void 0 : _data$lonlat3.lon, (_data$lonlat4 = data.lonlat) === null || _data$lonlat4 === void 0 ? void 0 : _data$lonlat4.lat])) {
                data = this.coordinatesToMetric(data);
              }
              _context2.n = 1;
              return this.getTransformedCoordinatesFromServer(data, fromProjection, toProjection);
            case 1:
              data = _context2.v;
            case 2:
              return _context2.a(2, data);
          }
        }, _callee2, this);
      }));
      function convertCoordinates(_x, _x2, _x3) {
        return _convertCoordinates.apply(this, arguments);
      }
      return convertCoordinates;
    }()
  }, {
    key: "updateLonLat",
    value: function updateLonLat(data) {
      var getDataFromServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var updateReverseGeoCode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var updateEmergencyCallInfo = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      if (!data || !data.lonlat) {
        // update with map coordinates if coordinates not given
        data = this.getMapXY();
      }
      this.updateState({
        xy: data
      });
      if (this.isReverseGeoCode && updateReverseGeoCode) {
        this.updateReverseGeocode(data);
      }
      if (updateEmergencyCallInfo) {
        this.getEmergencyCallInfo(data);
      }
      this.updateDisplayValues(data, getDataFromServer);
    }
  }, {
    key: "updateDisplayValues",
    value: function () {
      var _updateDisplayValues = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(data, getDataFromServer) {
        var _data, _data2, _data3, _data4;
        var fromServer, isSupported, isDifferentProjection, lat, lon, degreePoint, _t;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              fromServer = false;
              if (!getDataFromServer) {
                _context3.n = 2;
                break;
              }
              _context3.n = 1;
              return this.convertCoordinates(data, this.mapProjection, this.state.selectedProjection);
            case 1:
              data = _context3.v;
              fromServer = true;
              _context3.n = 6;
              break;
            case 2:
              if (!(this.isTransformAllowed() && this.state.selectedProjection !== this.mapProjection)) {
                _context3.n = 6;
                break;
              }
              _context3.p = 3;
              data = transformCoordinates(this.mapModule, data, this.mapProjection, this.state.selectedProjection);
              _context3.n = 6;
              break;
            case 4:
              _context3.p = 4;
              _t = _context3.v;
              _context3.n = 5;
              return this.convertCoordinates(data, this.mapProjection, this.state.selectedProjection);
            case 5:
              data = _context3.v;
            case 6:
              isSupported = !!(this.config && Array.isArray(this.config.supportedProjections));
              isDifferentProjection = !!(this.state.selectedProjection !== this.mapProjection && ((_data = data) === null || _data === void 0 || (_data = _data.lonlat) === null || _data === void 0 ? void 0 : _data.lat) !== 0 && ((_data2 = data) === null || _data2 === void 0 || (_data2 = _data2.lonlat) === null || _data2 === void 0 ? void 0 : _data2.lon) !== 0);
              lat = parseFloat((_data3 = data) === null || _data3 === void 0 || (_data3 = _data3.lonlat) === null || _data3 === void 0 ? void 0 : _data3.lat);
              lon = parseFloat((_data4 = data) === null || _data4 === void 0 || (_data4 = _data4.lonlat) === null || _data4 === void 0 ? void 0 : _data4.lon); // Need to show degrees ?
              if (this.isCurrentUnitDegrees() && !isNaN(lat) && !isNaN(lon)) {
                degreePoint = Oskari.util.coordinateMetricToDegrees([lon, lat], this.getProjectionDecimals());
                lon = degreePoint[0];
                lat = degreePoint[1];
              }
              // Otherwise show meter units
              else if (!isNaN(lat) && !isNaN(lon)) {
                lat = lat.toFixed(this.getProjectionDecimals());
                lon = lon.toFixed(this.getProjectionDecimals());
                lat = this.formatNumber(lat, this.decimalSeparator);
                lon = this.formatNumber(lon, this.decimalSeparator);
              }
              this.updateState({
                latField: lat,
                lonField: lon,
                approxValue: !fromServer && isSupported && isDifferentProjection
              });
            case 7:
              return _context3.a(2);
          }
        }, _callee3, this, [[3, 4]]);
      }));
      function updateDisplayValues(_x4, _x5) {
        return _updateDisplayValues.apply(this, arguments);
      }
      return updateDisplayValues;
    }()
  }, {
    key: "setSelectedProjection",
    value: function setSelectedProjection(projection) {
      this.updateState({
        selectedProjection: projection
      });
      this.updateDisplayValues(this.state.xy, true);
    }
  }, {
    key: "showPopup",
    value: function showPopup() {
      var _this2 = this;
      if (this.popupControls) {
        this.popupCleanup();
      } else {
        var _this$config3, _this$reverseGeocodin;
        this.popupControls = showCoordinatePopup(this.getState(), this.getController(), this.popupLocation(), (_this$config3 = this.config) === null || _this$config3 === void 0 ? void 0 : _this$config3.supportedProjections, ((_this$reverseGeocodin = this.reverseGeocodingIds) === null || _this$reverseGeocodin === void 0 ? void 0 : _this$reverseGeocodin.length) > 2, function () {
          return _this2.popupCleanup();
        });
        this.updateLonLat(this.getMapXY(), true, true, true);
        this.notifyPopupListeners(true);
      }
    }
  }, {
    key: "centerMap",
    value: function centerMap(coordinates) {
      try {
        var data = coordinates || this.state.xy;
        this.centerMapToSelectedCoordinates(data);
      } catch (e) {
        Messaging.error(this.loc('display.checkValuesDialog.message'));
      }
    }
  }, {
    key: "centerMapToSelectedCoordinates",
    value: function centerMapToSelectedCoordinates(data) {
      if (this.mapModule.isValidLonLat(data.lonlat.lon, data.lonlat.lat)) {
        this.sandbox.postRequestByName('MapMoveRequest', [data.lonlat.lon, data.lonlat.lat, this.sandbox.getMap().getZoom()]);
        this.updateLonLat(data, true, true, true);
      } else {
        Messaging.error(this.loc('display.checkValuesDialog.message'));
      }
    }
  }, {
    key: "setMarker",
    value: function setMarker() {
      var _displayData$lonlat, _data$lonlat5, _displayData$lonlat2, _data$lonlat6;
      this.centerMap();
      var data = this.state.xy || this.getMapXY();
      var displayData = {
        lonlat: {
          lon: this.state.lonField,
          lat: this.state.latField
        }
      } || this.getMapXY();
      var lat = (displayData === null || displayData === void 0 || (_displayData$lonlat = displayData.lonlat) === null || _displayData$lonlat === void 0 ? void 0 : _displayData$lonlat.lat) || (data === null || data === void 0 || (_data$lonlat5 = data.lonlat) === null || _data$lonlat5 === void 0 ? void 0 : _data$lonlat5.lat);
      var lon = (displayData === null || displayData === void 0 || (_displayData$lonlat2 = displayData.lonlat) === null || _displayData$lonlat2 === void 0 ? void 0 : _displayData$lonlat2.lon) || (data === null || data === void 0 || (_data$lonlat6 = data.lonlat) === null || _data$lonlat6 === void 0 ? void 0 : _data$lonlat6.lon);
      try {
        var msg = null;
        if (Oskari.util.coordinateIsDegrees([lon, lat]) && this.isCurrentUnitDegrees()) {
          msg = {
            lat: lat,
            lon: lon
          };
        } else {
          var _displayData$lonlat3, _displayData$lonlat4;
          msg = {
            lat: displayData === null || displayData === void 0 || (_displayData$lonlat3 = displayData.lonlat) === null || _displayData$lonlat3 === void 0 ? void 0 : _displayData$lonlat3.lat,
            lon: displayData === null || displayData === void 0 || (_displayData$lonlat4 = displayData.lonlat) === null || _displayData$lonlat4 === void 0 ? void 0 : _displayData$lonlat4.lon
          };
        }
        this.addMarker(data, msg);
      } catch (e) {
        Messaging.error(this.loc('display.checkValuesDialog.message'));
      }
    }
  }, {
    key: "addMarker",
    value: function addMarker(data, messageData) {
      var reqBuilder = Oskari.requestBuilder('MapModulePlugin.AddMarkerRequest');
      var lat = parseFloat(data.lonlat.lat);
      var lon = parseFloat(data.lonlat.lon);
      var inputLonLatData = {
        lonlat: {
          lat: lat,
          lon: lon
        }
      };

      // Check at data is given. If data is given then use for it.
      // If not then use input data's and try change data to map projection and use it to place marker
      try {
        data = data || transformCoordinates(this.mapModule, inputLonLatData, this.state.selectedProjection, this.mapProjection);
      } catch (err) {
        // Cannot transform coordinates in transformCoordinates -function
        Messaging.error(this.loc('cannotTransformCoordinates.message'));
        return;
      }
      lat = lat.toFixed(this.getProjectionDecimals());
      lon = lon.toFixed(this.getProjectionDecimals());
      if (reqBuilder) {
        var msgLon = messageData && messageData.lon ? messageData.lon : lon;
        var msgLat = messageData && messageData.lat ? messageData.lat : lat;
        var msg = msgLat + ', ' + msgLon;
        if (this.config.supportedProjections) {
          msg += ' (' + (this.loc("display.coordinatesTransform.projections.".concat(this.state.selectedProjection)) || this.state.selectedProjection) + ')';
        }
        var marker = {
          x: data.lonlat.lon,
          y: data.lonlat.lat,
          msg: msg,
          size: 5,
          color: 'ee9900',
          shape: 2
        };
        this.sandbox.request(this.plugin, reqBuilder(marker));
      }
    }
  }, {
    key: "getMapXY",
    value: function getMapXY() {
      var map = this.sandbox.getMap();
      var data = {
        lonlat: {
          lat: parseFloat(map.getY()),
          lon: parseFloat(map.getX())
        }
      };
      return data;
    }
  }, {
    key: "formatNumber",
    value: function formatNumber(coordinate, decimalSeparator) {
      if (typeof coordinate !== 'string') {
        coordinate = coordinate + '';
      }
      coordinate = coordinate.replace('.', decimalSeparator);
      coordinate = coordinate.replace(',', decimalSeparator);
      return coordinate;
    }
  }, {
    key: "isCurrentUnitDegrees",
    value: function isCurrentUnitDegrees() {
      var projection = this.state.selectedProjection || this.mapProjection;
      var formatDef = this.getProjectionShowFormat(projection);
      var defaultedToMapmodule = formatDef || this.mapModule.getProjectionUnits();
      return defaultedToMapmodule === 'degrees';
    }
  }, {
    key: "getTransformedCoordinatesFromServer",
    value: function () {
      var _getTransformedCoordinatesFromServer = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(data, fromProjection, toProjection) {
        var response, newData, _t2;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              this.setLoading(true);
              data = data || this.getMapXY();
              _context4.p = 1;
              _context4.n = 2;
              return getTransformedCoordinates(this.mapProjection, data, fromProjection, toProjection);
            case 2:
              response = _context4.v;
              if (!(response !== null && response !== void 0 && response.lat && response !== null && response !== void 0 && response.lon)) {
                _context4.n = 3;
                break;
              }
              newData = {
                lonlat: {
                  lon: response.lon,
                  lat: response.lat
                }
              };
              this.setLoading(false);
              return _context4.a(2, newData);
            case 3:
              this.setLoading(false);
              return _context4.a(2, data);
            case 4:
              _context4.n = 6;
              break;
            case 5:
              _context4.p = 5;
              _t2 = _context4.v;
              this.setLoading(false);
              Messaging.error(this.loc('display.cannotTransformCoordinates.message'));
            case 6:
              return _context4.a(2);
          }
        }, _callee4, this, [[1, 5]]);
      }));
      function getTransformedCoordinatesFromServer(_x6, _x7, _x8) {
        return _getTransformedCoordinatesFromServer.apply(this, arguments);
      }
      return getTransformedCoordinatesFromServer;
    }()
  }, {
    key: "updateReverseGeocode",
    value: function updateReverseGeocode(data) {
      var _this3 = this;
      var service = this.service;
      if (!this.popupControls || this.state.reverseGeocodeNotImplementedError) {
        return;
      }
      if (!data || !data.lonlat) {
        // update with map coordinates if coordinates not given
        data = this.getMapXY();
      }
      var reverseGeoCode = [];
      service.getReverseGeocode(
      // Success callback
      function (response) {
        var hasResponse = !!(response && response.length > 0);
        var locale = _this3.loc('display.reversegeocode');
        // type title is not found in locales
        if (hasResponse && locale[response[0].channelId]) {
          for (var i = 0; i < response.length; i++) {
            var r = response[i];
            var title = locale[r.channelId].label;
            if (!title) {
              title = r.type;
            }
            reverseGeoCode.push({
              title: title,
              name: r.name
            });
          }
          _this3.updateState({
            reverseGeoCode: reverseGeoCode
          });
        } else {
          _this3.updateState({
            reverseGeoCode: []
          });
        }
      },
      // Error callback
      function (jqXHR, textStatus, errorThrown) {
        if (jqXHR.status === 501) {
          _this3.updateState({
            reverseGeocodeNotImplementedError: true
          });
        }
        var messageJSON;
        try {
          messageJSON = jQuery.parseJSON(jqXHR.responseText);
        } catch (err) {}
        var message = 'Cannot reverse geocode';
        if (messageJSON && messageJSON.error) {
          message = messageJSON.error;
        }
        Oskari.log('coordinatetool').warn(message);
        _this3.updateState({
          reverseGeoCode: []
        });
      }, data.lonlat.lon, data.lonlat.lat);
    }
  }, {
    key: "getEmergencyCallCoordinatesFromServer",
    value: function () {
      var _getEmergencyCallCoordinatesFromServer = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(data) {
        var sourceProjection, response, newData, _t3;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              // get the transform from current data
              sourceProjection = this.mapProjection; // If coordinates are not  EPSG:4326 then
              // need to get 'EPSG:4326' coordinates from service
              if (!(sourceProjection !== 'EPSG:4326')) {
                _context5.n = 6;
                break;
              }
              _context5.p = 1;
              _context5.n = 2;
              return getTransformedCoordinates(this.mapProjection, data, sourceProjection, 'EPSG:4326');
            case 2:
              response = _context5.v;
              if (!(response !== null && response !== void 0 && response.lat && response !== null && response !== void 0 && response.lon)) {
                _context5.n = 3;
                break;
              }
              newData = {
                lonlat: {
                  lon: response.lon,
                  lat: response.lat
                }
              };
              return _context5.a(2, this.simplifyEmergencyData(newData));
            case 3:
              _context5.n = 5;
              break;
            case 4:
              _context5.p = 4;
              _t3 = _context5.v;
              Messaging.error(this.loc('display.cannotTransformCoordinates.message'));
            case 5:
              _context5.n = 7;
              break;
            case 6:
              return _context5.a(2, this.simplifyEmergencyData(data));
            case 7:
              return _context5.a(2);
          }
        }, _callee5, this, [[1, 4]]);
      }));
      function getEmergencyCallCoordinatesFromServer(_x9) {
        return _getEmergencyCallCoordinatesFromServer.apply(this, arguments);
      }
      return getEmergencyCallCoordinatesFromServer;
    }()
  }, {
    key: "getEmergencyCallInfo",
    value: function () {
      var _getEmergencyCallInfo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(data) {
        var _this4 = this;
        var xy;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              if (this.config.showEmergencyCallMessage) {
                _context6.n = 1;
                break;
              }
              return _context6.a(2);
            case 1:
              // update emergency if configured
              xy = data || this.getMapXY(); // already in degrees, don't fetch again
              if (!(this.isCurrentUnitDegrees() && this.mapProjection === 'EPSG:4326')) {
                _context6.n = 2;
                break;
              }
              this.updateState({
                emergencyInfo: this.simplifyEmergencyData({
                  lonlat: {
                    lon: xy.lonlat.lon,
                    lat: xy.lonlat.lat
                  }
                })
              });
              _context6.n = 3;
              break;
            case 2:
              _context6.n = 3;
              return this.getEmergencyCallCoordinatesFromServer(data).then(function (emergencyData) {
                _this4.updateState({
                  emergencyInfo: emergencyData
                });
              });
            case 3:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function getEmergencyCallInfo(_x0) {
        return _getEmergencyCallInfo.apply(this, arguments);
      }
      return getEmergencyCallInfo;
    }() // just simplifying the object
  }, {
    key: "simplifyEmergencyData",
    value: function simplifyEmergencyData(data) {
      return {
        lon: data.lonlat.lon,
        lat: data.lonlat.lat
      };
    }
  }, {
    key: "createEventHandlers",
    value: function createEventHandlers() {
      var _this5 = this;
      var handlers = {
        /**
         * @method MouseHoverEvent
         * See PorttiMouse.notifyHover
         */
        MouseHoverEvent: function MouseHoverEvent(event) {
          if (this.state.showMouseCoordinates && !this.state.loading) {
            var data = {
              lonlat: {
                lat: parseFloat(event.getLat()),
                lon: parseFloat(event.getLon())
              }
            };
            if (event.isPaused()) {
              this.updateLonLat(data, true, true, true);
            } else {
              this.updateLonLat(data, false, false, false);
            }
          }
        },
        /**
         * @method AfterMapMoveEvent
         * Shows map center coordinates after map move
         */
        AfterMapMoveEvent: function AfterMapMoveEvent(event) {
          if (!this.popupControls) return;
          if (!this.state.showMouseCoordinates) {
            this.updateLonLat(this.getMapXY(), true, true, true);
          }
        },
        /**
         * @method MapClickedEvent
         * @param {Oskari.mapframework.bundle.mapmodule.event.MapClickedEvent} event
         */
        MapClickedEvent: function MapClickedEvent(event) {
          if (!this.popupControls) return;
          var lonlat = event.getLonLat();
          var data = {
            lonlat: {
              lat: parseFloat(lonlat.lat),
              lon: parseFloat(lonlat.lon)
            }
          };
          if (!this.showMouseCoordinates) {
            this.updateLonLat(data, true, true, true);
          }
        }
      };
      Object.getOwnPropertyNames(handlers).forEach(function (p) {
        return _this5.sandbox.registerForEventByName(_this5, p);
      });
      return handlers;
    }
  }, {
    key: "onEvent",
    value: function onEvent(e) {
      var handler = this.eventHandlers[e.getName()];
      if (!handler) {
        return;
      }
      return handler.apply(this, [e]);
    }
  }]);
}(StateHandler);
var wrapped = controllerMixin(UIHandler, ['toggleMouseCoordinates', 'isCurrentUnitDegrees', 'showPopup', 'setMarker', 'centerMap', 'setLonInputValue', 'setLatInputValue', 'setLoading', 'setSelectedProjection', 'toggleReverseGeoCode', 'useUserDefinedCoordinates', 'isMapCentered', 'popupCleanup']);
export { wrapped as CoordinatePluginHandler };